import React from 'react'
import 'normalize.css'
import GlobalStyles from '../../styles/GlobalStyles'
import AccessibilityStyles from '../../styles/AccessibilityStyles'
import Navigation from './Navigation'

export default function Layout({ children }) {
  return (
    <>
      <GlobalStyles />
      <AccessibilityStyles />
      <Navigation />
      {children}
    </>
  )
}
